// src/components/rental-managers/WelcomeSection.jsx



import React from 'react';
import { Box, Typography, Grid } from '@mui/material';
import WelcomeSectionStyles from './WelcomeSection.styles';

const WelcomeSection = () => {
  return (
    <Box sx={WelcomeSectionStyles.container}>
      <Grid container spacing={6} alignItems="center">
        {/* Left Side - Text */}
        <Grid item xs={12} md={6} sx={WelcomeSectionStyles.textContainer}>
          <Typography variant="h2" sx={WelcomeSectionStyles.title}>
            WELCOME
          </Typography>
          <Typography variant="h3" sx={WelcomeSectionStyles.subtitle}>
            TO PROPERTY MANAGEMENT IN <br /> THE NEW AGE
          </Typography>
        </Grid>

        {/* Right Side - Step Timeline */}
        <Grid item xs={12} md={6} sx={WelcomeSectionStyles.stepsContainer}>
          <Box sx={WelcomeSectionStyles.timeline}>
            {[
              { step: '1', text: 'Order Hardware/Confirm Compatibility', align: 'right' },
              { step: '2', text: 'Register Properties and Users Manually or Sync from Property Management Software', align: 'left' },
              { step: '3', text: 'Install and Connect Smart Locks/Devices', align: 'right' },
              { step: '4', text: 'Activate Access Subscription or Showings on Property Manager Dashboard', align: 'left' },
            ].map((item, index) => (
              <Box key={index} sx={WelcomeSectionStyles.stepContainer}>
                {/* Step Label (Green Brush Effect) */}
                <Box sx={item.align === 'right' ? WelcomeSectionStyles.stepLabelRight : WelcomeSectionStyles.stepLabelLeft}>
                  <Typography sx={WelcomeSectionStyles.stepLabel}>STEP {item.step}:</Typography>
                </Box>

                {/* Dotted Timeline with Circle */}
                <Box sx={WelcomeSectionStyles.timelineItem}>
                  <Box sx={WelcomeSectionStyles.stepCircle} />
                </Box>

                {/* Step Text */}
                <Box sx={item.align === 'right' ? WelcomeSectionStyles.stepTextRight : WelcomeSectionStyles.stepTextLeft}>
                  <Typography sx={WelcomeSectionStyles.stepText}>{item.text}</Typography>
                </Box>
              </Box>
            ))}

            {/* Final Growth Step */}
            <Box sx={WelcomeSectionStyles.stepContainer} justifyContent="center">
              <Box sx={WelcomeSectionStyles.timelineItem}>
                <Box sx={WelcomeSectionStyles.stepCircle} />
              </Box>
              <Box sx={WelcomeSectionStyles.growLabelWrapper}>
                <Typography sx={WelcomeSectionStyles.growLabel}>GROW</Typography>
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default WelcomeSection;



